








































































import { Component, Vue } from "vue-property-decorator";
import * as _ from 'underscore';

import { namespace } from "vuex-class";   
import "@/store/modules/common";
import { userInfoType } from "@/types/Admin";
const commonState = namespace("Common");

@Component
export default class NavigationTopbar extends Vue {
    
    @commonState.State
    public user!: userInfoType;

    @commonState.Action
    UpdateUser!: (newUser: userInfoType) => void 
    
    @commonState.Action
    UpdateToken!:(newToken: string) => void

    dismissCountDown =0
    alertType=""


    public logout() {
        if(this.$store.state.Common.logoutUrl){
            this.UpdateUser(null);
            this.UpdateToken(null);
            window.location.replace(this.$store.state.Common.logoutUrl);
        } 
        else
            this.$http.get('/auth/logout').then(response =>{
                this.UpdateUser(null);
                this.UpdateToken(null);
                this.$router.push({ name: "home" });
            }) 
    }

    public userProfile(){
        if(!location.pathname.includes('/user-profile'))
            this.$router.push({ name: "user-profile" });
    }

    public manageBookings(){
        if(!location.pathname.includes('/manage-bookings'))
            this.$router.push({ name: "manage-bookings" });
    }

    public addBookings(){
        if(!location.pathname.includes('/add-bookings'))
            this.$router.push({ name: "add-bookings" });
    }

   
    public countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    }

   

}
